export default {
    methods: {
        /**
         * @param person - May contain:
         *   - name.first / name.last / name.preferred
         *   - OR flat first / last / preferred
         * @param options
         *   - format: 'firstLast' | 'lastFirst'
         *   - usePreferred: boolean
         * @returns {string}
         */
        getPersonName(person, options = {}) {
            if (!person) return ''

            const {
                format = 'firstLast',
                usePreferred = false,
            } = options

            const first = person?.name?.first ?? person?.first ?? ''
            const last = person?.name?.last ?? person?.last ?? ''
            const preferred = person?.name?.preferred ?? person?.preferred ?? ''

            // Decide which "first" value to use
            const displayFirst = usePreferred && preferred
                    ? preferred
                    : first

            if (!displayFirst && !last) return ''

            if (format === 'lastFirst') {
                return displayFirst
                    ? `${last}, ${displayFirst}`
                    : last
            }

            // default: "First Last"
            return `${displayFirst} ${last}`.trim()
        },
    },
}
